import { Component, OnInit, Input } from '@angular/core';
import { NewsArticle } from '@models/newsArticle';
import { NewsArticleService } from '@services/news-article.service';
import { SlugifyPipe } from '@pipes/slugify.pipe';

@Component({
  selector: 'csl-small-post',
  templateUrl: './small-post.component.html'
})
export class SmallPostComponent implements OnInit {
  @Input()
  newsArticle: NewsArticle;

  @Input()
  articleWidth: string;

  @Input()
  textLimit: string;

  @Input()
  datePipe = 'MMM d, y';

  constructor(private slugifyPipe: SlugifyPipe, private newsArticleService: NewsArticleService) { }

  ngOnInit(): void {
    if (this.newsArticle){
      this.newsArticle.articleSection = this.newsArticleService.getMapSectionDescription(this.newsArticle.articleSection);
      this.newsArticle.articleTitleSlug = this.slugifyPipe.transform(this.newsArticle.articleTitle);
    }
  }

}
